export enum RoutesEnum {
 Dashboard = 'dashboard',
 ItemList = 'item-list',
 BrandList = 'brand-list',
 ColorList = 'color-list',
 PurchaseOrderList = 'po-list',
 PurchaseOrderForm = 'po-form',
 SaleOrderList = 'so-list',
 SaleOrderForm = 'so-form',
 AccountTrialBalance = 'rpt-act-trial-balance',
 AgentAccountTrialBalance = 'rpt-agt-act-trial-balance',
 PurchaseOrderItemBalance = 'rpt-po-pi-item-balance',
 SaleOrderItemBalance = 'rpt-so-si-item-balance',
 Logout = 'auth/logout',
 Login = 'auth/login',
}